import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/vendors/home/Page";

export const PATH = "/vendors";

const Home: NextPage = () => (
	<>
		<NskHead title="ダッシュボード" />
		<Component />
	</>
);

export default Home;
